import { render, staticRenderFns } from "./playlist-detail.vue?vue&type=template&id=ae8ae228&scoped=true&"
import script from "./playlist-detail.vue?vue&type=script&lang=js&"
export * from "./playlist-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8ae228",
  null
  
)

export default component.exports